module.exports = __webpack_public_path__ + "static/media/biriyani.02bc9d3c.jpeg";